module.exports = __webpack_public_path__ + "img/10_34.9331bbd7.png";